/* TYMWORK - toma el color dominante de la foto de cada paso del tarjetero
   y lo aplica al fondo de esa capa. Las imágenes de Shopify permiten leerse
   desde canvas (CORS abierto en su CDN). */
(function () {
  'use strict';
  if (window.__twColor) return; window.__twColor = 1;

  function dominante(img, cb) {
    var c = document.createElement('canvas');
    var n = 24; c.width = n; c.height = n;
    var x = c.getContext('2d', { willReadFrequently: true });
    try {
      x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data;
      var r = 0, g = 0, b = 0, cuenta = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 120) continue;
        var lum = (d[i] * 299 + d[i + 1] * 587 + d[i + 2] * 114) / 1000;
        if (lum > 245 || lum < 8) continue;   // ignora blanco puro y negro puro
        r += d[i]; g += d[i + 1]; b += d[i + 2]; cuenta++;
      }
      if (!cuenta) return;
      cb('rgb(' + Math.round(r / cuenta) + ',' + Math.round(g / cuenta) + ',' + Math.round(b / cuenta) + ')');
    } catch (e) { /* imagen sin permiso de lectura: se queda el color manual */ }
  }

  function aplicar() {
    Array.prototype.forEach.call(document.querySelectorAll('.tw-scroll'), function (sec) {
      if (sec.dataset.twAutoColor !== 'true') return;
      Array.prototype.forEach.call(sec.querySelectorAll('.tw-layer'), function (capa) {
        if (capa.dataset.color) return;
        var img = capa.querySelector('img');
        if (!img) return;
        var listo = function () {
          capa.dataset.color = '1';
          dominante(img, function (color) {
            capa.style.background = color;
            var t = capa.querySelector('.tw-layer__tinte');
            if (t) t.style.background = color;
          });
        };
        if (img.complete && img.naturalWidth) { listo(); }
        else {
          img.crossOrigin = 'anonymous';
          img.addEventListener('load', listo, { once: true });
        }
      });
    });
  }

  function boot() { aplicar(); setTimeout(aplicar, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', aplicar);
})();
